var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.badge},[_vm._t("default"),_vm._v(" "),_c('client-only',[(_vm.content)?_c('div',{class:[
        _vm.$style.content,
        _vm.colorType,
        ( _obj = {}, _obj[_vm.$style.circle] = _vm.circle, _obj[_vm.$style.text] = !_vm.circle, _obj ) ]},[(!_vm.circle)?[_vm._v(_vm._s(_vm.content))]:_vm._e()],2):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }